import dayjs from "dayjs";
import {
  handleValidateCodevalue,
  ACTIONABLES_CALENDAR_DEFAULT_STATUS_COLOR,
  ACTIONABLES_CALENDAR_PILL_BG_OPACITY,
  ACTIONABLES_CALENDAR_PILL_HOVER_OPACITY,
  ACTIONABLES_CALENDAR_PAST_MONTHS_LIMIT,
  ACTIONABLES_CALENDAR_FUTURE_MONTHS_LIMIT
} from "./constant";


export const parseCronToTime = (cron) => {
  if (!cron) return null;
  try {
    const parts = cron.trim().split(' ');
    const minute = parseInt(parts[1], 10);
    const hour   = parseInt(parts[2], 10);
    if (isNaN(minute) || isNaN(hour)) return null;
    return dayjs().hour(hour).minute(minute).second(0);
  } catch {
    return null;
  }
};

export const parseTimeToDayjs = (timeStr) => {
  if (!timeStr) return null;
  try {
    const [timePart, meridiem] = timeStr.trim().split(' ');
    const [h, m] = timePart.split(':').map(Number);
    if (isNaN(h) || isNaN(m)) return null;
    let hour = h;
    if (meridiem?.toUpperCase() === 'PM' && h < 12)  hour += 12;
    if (meridiem?.toUpperCase() === 'AM' && h === 12) hour  = 0;
    return dayjs().hour(hour).minute(m).second(0);
  } catch {
    return null;
  }
};


export const discountCalculation = (setDiscount , discount,name,value,numValue,internationalise,enqueueSnackbar)=>{
      const productPrice = discount?.productPrice || 0;
    
      let primaryDiscount = discount?.primaryDiscount || 0;
      let discountAmount = discount?.discountAmount || 0;
      let pricePostDiscount = discount?.pricePostDiscount || 0;
      let totalDiscountAmount = discount?.totalDiscountAmount || 0;
      let totalAmount = discount?.totalAmount || 0;
      let sgstAmount = discount?.sgstAmount || 0;
      let cgstAmount = discount?.cgstAmount || 0;
      let surchargeAmount = discount?.surchargeAmount || 0;
    
      if (name === "primaryDiscount") {
        discountAmount = (productPrice * numValue) / 100;
        pricePostDiscount = (productPrice - discountAmount) * discount?.quantity;
        totalDiscountAmount = discountAmount * discount?.quantity;
        sgstAmount = (pricePostDiscount * discount?.sgst) /100;
        cgstAmount = (pricePostDiscount * discount?.cgst) /100;
        surchargeAmount = ((pricePostDiscount + sgstAmount + cgstAmount) * discount?.surCharge) /100;
        totalAmount = pricePostDiscount + sgstAmount + cgstAmount + surchargeAmount;
    
        setDiscount({
          ...discount,
          totalAmount,
          primaryDiscount: numValue,
          discountAmount,
          pricePostDiscount,
          totalDiscountAmount
        });
      }
    
      if (name === "discountAmount") {
        if(value > discount?.productPrice){
            enqueueSnackbar(handleValidateCodevalue(internationalise,"DISCOUNT_AMOUNT_WARNING"),{variant : "warning"})
            return;
        }
        discountAmount = numValue;
        primaryDiscount = ((discountAmount / productPrice) * 100).toFixed(2);
        pricePostDiscount = (productPrice - discountAmount) * discount?.quantity;
        totalDiscountAmount = discountAmount * discount?.quantity;
        sgstAmount = (pricePostDiscount * discount?.sgst) /100;
        cgstAmount = (pricePostDiscount * discount?.cgst) /100;
        surchargeAmount = ((pricePostDiscount + sgstAmount + cgstAmount) * discount?.surCharge) /100;
        totalAmount = pricePostDiscount + sgstAmount + cgstAmount + surchargeAmount;
    
        setDiscount({
          ...discount,
          totalAmount,
          discountAmount,
          primaryDiscount,
          pricePostDiscount,
          totalDiscountAmount
          
        });
      }
}

export const salesOrderInvoiceDialog = (newRecord) => {
  const round2 = (num) => Number(Number(num || 0).toFixed(2));
  
  const qty = Number(newRecord?.invoiceqty || 0);
  const price = Number(newRecord?.price || 0);
  const primaryDiscount = Number(newRecord?.primaryDiscount || 0);
  const sGst = Number(newRecord?.sGst || 0);
  const cGst = Number(newRecord?.cGst || 0);
  const surchargeRate = Number(newRecord?.surchargeRate || 0);

  const discountAmount = round2(price * primaryDiscount)/100;
  const totalDiscountAmount = round2(price * primaryDiscount * qty)/100;
  const priceAfterDiscount = round2((price - discountAmount) * qty);
  const sgstAmount = round2((priceAfterDiscount * sGst) / 100);
  const cgstAmount = round2((priceAfterDiscount * cGst) / 100);
  const surchargeAmount = round2(((priceAfterDiscount + sgstAmount + cgstAmount) * surchargeRate) / 100);

  const totalPrice = round2(
    priceAfterDiscount + sgstAmount + cgstAmount + surchargeAmount
  );
  return {totalDiscountAmount,discountAmount,priceAfterDiscount,sgstAmount,cgstAmount,surchargeAmount,totalPrice};
};

export const startOfDay = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};

export const truncateText = (text, maxLength) => {
  const value = text || '';
  return value.length > maxLength ? `${value.substring(0, maxLength)}...` : value;
};

export const hexToRgba = (hex, alpha = 0.15) => {
  if (!hex) return `rgba(121, 177, 204, ${alpha})`;

  let cleanHex = hex.replace('#', '');
  if (cleanHex.length === 3) {
    cleanHex = cleanHex.split('').map((character) => character + character).join('');
  }

  const numericValue = Number.parseInt(cleanHex, 16);
  if (Number.isNaN(numericValue)) return `rgba(121, 177, 204, ${alpha})`;

  const red = (numericValue >> 16) & 255;
  const green = (numericValue >> 8) & 255;
  const blue = numericValue & 255;
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};


export const isPastDate = (date) => {
  const today = startOfDay(new Date());
  const target = startOfDay(date);
  return target.getTime() < today.getTime();
};


export const isFutureDate = (date) => {
  const today = startOfDay(new Date());
  const target = startOfDay(date);
  return target.getTime() > today.getTime();
};


export const isToday = (date) => {
  const today = startOfDay(new Date());
  const target = startOfDay(date);
  return target.getTime() <= today.getTime();
};


export const isNext7Days = (date) => {
  const today = startOfDay(new Date());
  const target = startOfDay(date);
  const seventhDay = new Date(today);
  seventhDay.setDate(today.getDate() + 7);
  
  return target > today && target <= seventhDay;
};

export const isNext60Days = (date) => {
  const today = startOfDay(new Date());
  const target = startOfDay(date);
  const sixtyDaysLater = new Date(today);
  sixtyDaysLater.setDate(today.getDate() + 60);
  
  return target > today && target <= sixtyDaysLater;
};


export  const getTotalAttachmentSize = (selectedTemplate,newAttachments) => {
  const existingSize =
    selectedTemplate?.attachments?.reduce(
      (sum, att) => sum + (att.file_size || 0),
      0
    ) || 0;

  const newSize =
    newAttachments.reduce((sum, file) => sum + file.size, 0);

  return existingSize + newSize;
};

export   const formatFileSize = (bytes = 0) => {
    if (!bytes) return "0 MB";
    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${(bytes / Math.pow(k, i)).toFixed(2)} ${["B","KB","MB"][i]}`;
  };
export const getMimeFromFile = (name = "") => {
    const ext = name.split(".").pop()?.toLowerCase();
    if (["jpg","jpeg","png","gif","webp"].includes(ext)) return `image/${ext}`;
    if (ext === "pdf") return "application/pdf";
    return "application/octet-stream";
  };

export const formatDuration = (ms) => {
  if (ms == null) return '—';
  if (ms < 1000) return `${ms}ms`;
  const seconds = ms / 1000;
  if (seconds < 60) {
    return `${seconds.toFixed(1)}s`;
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.round(seconds % 60);
  if (minutes < 60) {
    return `${minutes}m ${remainingSeconds}s`;
  }
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}h ${remainingMinutes}m`;
};

export const getActionableEventCssVars = (
  statusStyle,
  bgOpacity = ACTIONABLES_CALENDAR_PILL_BG_OPACITY,
  hoverOpacity = ACTIONABLES_CALENDAR_PILL_HOVER_OPACITY
) => {
  const solidColor = statusStyle?.backgroundColor || ACTIONABLES_CALENDAR_DEFAULT_STATUS_COLOR;
  return {
    '--event-bg': hexToRgba(solidColor, bgOpacity),
    '--event-hover-bg': hexToRgba(solidColor, hoverOpacity),
    '--event-color': solidColor,
    '--event-left-border': `3.5px solid ${solidColor}`
  };
};

export const groupActionablesByDate = (normalizedData = []) => {
  const map = {};
  normalizedData.forEach((item) => {
    let cur = dayjs(item.startDate);
    const end = dayjs(item.endDate);

    if (!cur.isValid() || !end.isValid()) {
      const dateKey = item.endDate || item.startDate;
      if (dateKey) {
        if (!map[dateKey]) map[dateKey] = [];
        map[dateKey].push(item);
      }
      return;
    }

    while (cur.isBefore(end) || cur.isSame(end, 'day')) {
      const dateKey = cur.format('YYYY-MM-DD');
      if (!map[dateKey]) map[dateKey] = [];
      map[dateKey].push(item);
      cur = cur.add(1, 'day');
    }
  });
  return map;
};

export const buildCalendarMonthGrid = (currentDate) => {
  const startOfMonth = currentDate.startOf('month');
  const endOfMonth = currentDate.endOf('month');
  const startDay = startOfMonth.startOf('week');
  const endDay = endOfMonth.endOf('week');

  const weeks = [];
  let currentDay = startDay;
  const todayStr = dayjs().format('YYYY-MM-DD');

  while (currentDay.isBefore(endDay) || currentDay.isSame(endDay, 'day')) {
    const week = [];
    for (let i = 0; i < 7; i++) {
      const dateStr = currentDay.format('YYYY-MM-DD');
      week.push({
        dateStr,
        dayNumber: currentDay.date(),
        isCurrentMonth: currentDay.month() === currentDate.month(),
        isToday: dateStr === todayStr,
        isWeekend: i === 0 || i === 6
      });
      currentDay = currentDay.add(1, 'day');
    }
    weeks.push(week);
  }
  return weeks;
};

export const isCalendarPrevDisabled = (currentDate, pastLimit = ACTIONABLES_CALENDAR_PAST_MONTHS_LIMIT) => {
  const today = dayjs().startOf('month');
  const prevMonth = currentDate.subtract(1, 'month');
  return today.diff(prevMonth, 'month') > pastLimit;
};

export const isCalendarNextDisabled = (currentDate, futureLimit = ACTIONABLES_CALENDAR_FUTURE_MONTHS_LIMIT) => {
  const today = dayjs().startOf('month');
  const nextMonth = currentDate.add(1, 'month');
  return nextMonth.diff(today, 'month') > futureLimit;
};

